<template>
  <v-container fluid>
    <v-layout mt-4 row wrap>
      <v-flex xs12 md4 pr-4>
        <v-facility
          :label="`Name:`"
          :rules="[rules.SchoolName]"
          v-model="PracticeSiteInformation.SiteAddress"
          :readonly="disableFields"
        ></v-facility>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-text-field
          required
          :rules="[rules.SchoolName]"
          v-model="PracticeSiteInformation.MedicalDirectorName"
          :label="`${PracticeSiteInformation.SiteAddress.SiteInsitutionName} Medical Director Name`"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md4>
        <v-text-field
          required
          :rules="[rules.SchoolName]"
          v-model="PracticeSiteInformation.SiteContactNameTitle"
          :label="`${PracticeSiteInformation.SiteAddress.SiteInsitutionName} Site Contact Name and Title`"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 md4 pr-4>
        <v-text-field
          readonly
          v-model="PracticeSiteInformation.SiteAddress.Address1"
          :label="`Address`"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md2 pr-4>
        <v-text-field  
          label="City" 
          v-model="PracticeSiteInformation.SiteAddress.City" 
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md2 pr-4>
        <v-text-field 
          label="State"
          v-model="PracticeSiteInformation.SiteAddress.State" 
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md2 pr-4>
        <v-text-field 
          label="Zip"
          v-model="PracticeSiteInformation.SiteAddress.Zip" 
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md2 pr-4>
        <v-text-field 
          label="County"
          v-model="PracticeSiteInformation.SiteAddress.County" 
          readonly
        ></v-text-field>
      </v-flex>
    </v-layout>


    <v-layout row wrap>
      <v-flex xs12 md6 pr-4>
        <v-text-field
          required
          :rules="[rules.Phone]"
          v-model="PracticeSiteInformation.Phone"
          label="Phone"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 md6 pr-4>
        <v-text-field
          required
          :rules="[rules.Email]"
          v-model="PracticeSiteInformation.Email"
          label="Email"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 md6 pr-4>
        <date-picker
          label="Employment Date"
          v-model="PracticeSiteInformation.EmploymentDate"
          :rules="[rules.DateRequired]"
          :disabled="disableFields"
        ></date-picker>
      </v-flex>

      <v-flex xs6 md6 pr-4>
        <v-text-field
          v-model="PracticeSiteInformation.HoursWorkedAtthisSite"
          :label="`Hours per Week Worked at ${PracticeSiteInformation.SiteAddress.SiteInsitutionName}`"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field
          required
          :rules="[rules.HPSADesignationID]"
          v-model="PracticeSiteInformation.HPSADesignationID"
          label="HPSA ID:"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>

      <v-flex xs12>
        <v-text-field
          required
          :rules="[rules.HPSAScore]"
          v-model="PracticeSiteInformation.HPSAScore"
          label="HPSA Score"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
    </v-layout>
     <v-layout row wrap>
      <v-flex xs12 md2>Designation Type
        </v-flex>    
      
  
   <v-flex xs12 md8 >
     <v-layout row wrap>
       <v-flex xs12 md4>
        <v-checkbox
          color='primary'
          label="Geographic"
          v-model="PracticeSiteInformation.DesignationTypeGeographic"
        ></v-checkbox> 
       </v-flex>
        <v-flex xs12 md4>
        <v-checkbox
          color='primary'
          label="Low-Income"
          v-model="PracticeSiteInformation.DesignationTypeLowIncome"
        ></v-checkbox>
         </v-flex>
        <v-flex xs12 md4>
        <v-checkbox
          color='primary'
          label="Facility"
          v-model="PracticeSiteInformation.DesignationTypeFacility"
        ></v-checkbox>
        </v-flex>
           </v-layout>
      </v-flex> 
  </v-layout>

   <v-layout row wrap>
      <v-flex xs12 md2>HPSA Type
        </v-flex>    
      
  
   <v-flex xs12 md8 >
     <v-layout row wrap>
       <v-flex xs12 md4>
        <v-checkbox
          color='primary'
          label="Primary Care"
          v-model="PracticeSiteInformation.HPSATypePrimaryCare"
        ></v-checkbox> 
       </v-flex>
        <v-flex xs12 md4>
        <v-checkbox
          color='primary'
          label="Dental"
          v-model="PracticeSiteInformation.HPSATypeDental"
        ></v-checkbox>
         </v-flex>
        <v-flex xs12 md4>
        <v-checkbox
          color='primary'
          label="Mental Health"
          v-model="PracticeSiteInformation.HPSATypeMentalHealth"
        ></v-checkbox>
        </v-flex>
           </v-layout>
      </v-flex> 
  </v-layout>

<v-layout>
       <v-flex xs12 md6 pr-4>
        <v-checkbox
          color="primary" 
          label="Is Primary Practice Site"
          v-model="PracticeSiteInformation.IsPrimarySite"
          :readonly="disableFields"
        ></v-checkbox>
      </v-flex>
    </v-layout>    

    <v-layout>      
      <v-flex xs12 md12 mt-4>
        <v-radio-group row
          :label="`Is ${PracticeSiteInformation.SiteAddress.SiteInsitutionName} an approved National Health Service Corps site?`"
          :rules="[rules.AdditionalNationalHealthServiceCorpsSite]"
          v-model="PracticeSiteInformation.IsthisAdditionLocationApprovedNationalHealthSCSite"
          :readonly="disableFields"
        >
          <v-radio label="Yes"  :value="true"></v-radio>
          <v-radio label="No"  :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>     
    
  </v-container>
</template>


<script>
import Rules from '../../validation/rules'
import LuFacilitiesVue from './LuFacilities.vue';
import DatePickerVue from '../DatePicker.vue';
export default {
  name: 'PracticeSiteInformationInformation',
  props: {
    PracticeSiteInformation: Object,
    idx: Number,
    disableFields: Boolean
  },
  data() {
    return {
      menu: false,
      rules: Rules,
    }
  },
  methods: {
    removePracticeSiteInformations(idx) {
      this.$emit('removePracticeSiteInformations', idx)
    },
  },

  components: {
    'v-facility' : LuFacilitiesVue,
    'date-picker' : DatePickerVue
  },
  watch: {
    PracticeSiteInformation: {
      handler(val) {
        this.$emit('siteUpdate', {val:val, idx:this.idx})
      },
      deep: true,
    },
    'PracticeSiteInformation.SiteAddress':{
      handler(val){
        this.PracticeSiteInformation.SiteAddressID = val.ID
      },
      deep: true
    }
  },
}
</script>